module.exports = __webpack_public_path__ + "perf.html";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[name].[ext]!./test/perf.html?
// module id = 86
// module chunks = 2